export enum resourceType {
  Admin = 'Admin',

  Settings = 'Settings',
  CreateUser = 'CreateUser',
  Offer = 'Offer',
  OfferMainData = 'OfferMainData',
  CountryStatistic = 'CountryStatistic',
  OfferBookCountryStatistic = 'OfferBookCountryStatistic',
  RtbCountryStatistic = 'RtbCountryStatistic',
  Users = 'Users',
  Partners = 'Partners',
  Ltv = 'Ltv',
  RtbStatistic = 'RtbStatistic',
  Hosts = 'Hosts',
  HostPublisherFilter = 'HostPublisherFilter',
  CountriesByHosts = 'CountriesByHosts',
  StatisticComparisonByDays = 'StatisticComparisonByDays',
  FullStatisticData = 'FullStatisticData',
  FullStatisticWithRatesData = 'FullStatisticWithRatesData', // allows to show RECPM and PRECPM at `hosts` and `host-by-countries` pages

  // trends
  Trends = 'Trends',
  TrendsEarningRateToggle = 'TrendsEarningRateToggle',
  TrendsMainStat = 'TrendsMainStat',
  TrendsMainUsersIPDStat = 'TrendsMainUsersIPDStat',
  TrendsOffers = 'TrendsOffers',
  TrendsPackages = 'TrendsPackages',
  TrendsRTB = 'TrendsRTB',
  TrendsManagers = 'TrendsManagers',
  TrendsHosts = 'TrendsHosts',
  TrendsAllHosts = 'TrendsAllHosts',

  // actions
  FilterByUser = 'FilterByUser',
  OfferActions = 'OfferActions',
  PartnerActions = 'PartnerActions',
  OfferSummaryStatistic = 'OfferSummaryStatistic',
  RTBSummaryStatistic = 'RTBSummaryStatistic',
  HostSummaryStatistic = 'HostSummaryStatistic',
}
